@if (show$ | async) {
  <div class="pwa-push-banner" role="dialog" aria-label="Activer les notifications">
    <span class="ic" aria-hidden="true">
      <svg viewBox="0 0 24 24">
        <path
          d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 0 1-3.4 0"
        />
      </svg>
    </span>
    <span class="txt">
      <b>Activer les notifications</b>
      <span>Soyez prévenu d'un nouveau document ou message.</span>
    </span>
    <button
      class="btn"
      type="button"
      [class.busy]="busy$ | async"
      [attr.aria-busy]="busy$ | async"
      [disabled]="busy$ | async"
      (click)="enable()"
    >
      Activer
    </button>
    <button class="close" type="button" aria-label="Fermer" (click)="dismiss()">
      &times;
    </button>
  </div>
}
